import { AdHocAgentNodeDataSchema, ResourceType } from '@cotera/api';
import { Ty } from '@cotera/era';
import type { WorkflowNodeData } from '../types';
import type {
  WorkflowNodeHydration,
  WorkflowNodeResourceRef,
} from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { nonBlank } from './output-shape-helpers';
import { TypedWorkflowNode } from './typed-workflow-node';

export class AdHocAgentWorkflowNode extends TypedWorkflowNode<
  typeof AdHocAgentNodeDataSchema
> {
  protected readonly schema = AdHocAgentNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): AdHocAgentWorkflowNode {
    return new AdHocAgentWorkflowNode(data, hydration);
  }
  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    const explicit = nonBlank(this.config?.outputShape);
    if (explicit !== undefined) {
      return explicit;
    }
    const agentId = nonBlank(this.config?.agentId);
    if (agentId !== undefined) {
      const linked = context.resolveAgentOutputShape(agentId);
      if (linked !== null) {
        return linked;
      }
    }
    return Ty.displayTy(Ty.ty('string'));
  }

  override resourceRefs(): readonly WorkflowNodeResourceRef[] {
    const agentId = nonBlank(this.config?.agentId);
    return agentId === undefined
      ? []
      : [{ type: ResourceType.Agent, id: agentId, field: 'agentId' }];
  }

  protected override defaultDisplayName(): string {
    return 'Ad hoc agent';
  }
}
